module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pending) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("UnSubscribing..")]) : _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n      Successfully removed "), _c('strong', [_vm._v(_vm._s(_vm.email))]), _vm._v(" from our mailing list.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Thank you for being part of Dupaws.com")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35abb19f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnSubscribe.vue
// module id = 624
// module chunks = 2